const styles = {
    LOGIN_CONTAINER: { 
        backgroundImage: 'url("https://www.app.linkplease.co/assests/bg.svg")',
        backgroundSize: 'cover',
        backgroundAttachment: 'fixed',
        minHeight: '100vh',
        width: '100%'
      }
}

export default styles